import React, { useContext } from "react"
import Button from "../atoms/button.atom"
import Input from "../atoms/input.atom"
import { CogIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import { toast } from "react-toastify"
import { AuthContext } from "../../context/auth.context"
import { validateYup } from "../template-info/templateUtils"
import * as yup from "yup"
import { Header } from "../common/header"
import Select from "../atoms/select.atom"
import { getCookie } from "../../helper/auth"

export const UpdateSenderId = ({ hubId, onUpdateRecord }) => {
	const { auth } = useContext(AuthContext)
	const selectedData = auth.passData

	const [configs, setConfigs] = React.useState([])
	const [selectedSMSConfig, setSelectedSMSConfig] = React.useState({})
	const [form, setForm] = React.useState({
		senderId: "",
		name: ""
	})

	const [loading, setLoading] = React.useState(false)
	const [errors, setErrors] = React.useState({})

	const getConfigs = () => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.hubAppConfig, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			const allConfigsRes = res.data.data || []
			setConfigs(allConfigsRes)
			const selectedConfigData = allConfigsRes.find((c) => c._id === selectedData.smsConfigId)
			setSelectedSMSConfig({
				label: selectedConfigData.name,
				value: selectedConfigData._id
			})
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	React.useEffect(() => {
		getConfigs()
		setForm({
			...form,
			senderId: selectedData.senderId,
			name: selectedData.name
		})
	}, [])

	const update = () => {
		let schema = yup.object().shape({
			senderId: yup.string().trim().required("Required"),
			smsConfigId: yup.string().trim().required("Required"),
			name: yup
				.string()
				.trim()
				.required("Required")
				.matches(
					/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
					"Only alphabets are allowed for this field "
				)
		})
		let finalObj = {
			hubId: hubId,
			recordId: selectedData._id,
			senderId: form.senderId,
			smsConfigId: selectedSMSConfig.value,
			name: form.name
		}
		validateYup(schema, finalObj)
			.then(() => {
				setErrors({})
				setLoading(true)
				;(async () => {
					const token = getCookie("token")
					await axiosInstance.put(EndpointConfig.hubAppConfigSender, finalObj, {
						headers: {
							Authorization: `Bearer ${token}`
						}
					})
					toast("Updated Successfully")
					onUpdateRecord?.()
				})()
					.catch(console.err)
					.finally(() => setLoading(false))
			})
			.catch(setErrors)
	}

	let thatConfig = configs.find((c) => c._id === selectedSMSConfig.value)

	return (
		<div className="flex flex-col">
			<Header IconName={CogIcon} subText={"Setup"} mainText={"Update Sender Id"} />
			<div className="flex flex-col gap-1 p-4 bg-white rounded">
				<div className="flex flex-row gap-6">
					<Input
						name="name"
						error={errors?.name}
						value={form.name}
						label={"Record Name"}
						placeholder={"Record Name"}
						onChange={(e) => setForm({ ...form, name: e.target.value })}
					/>
					{/* <Input name='DLTEntityId' error={errors?.DLTEntityId}
                        value={form.DLTEntityId}
                        label={'DLTEntityId'} placeholder={'DLTEntityId'}
                        onChange={(e) => setForm({ ...form, DLTEntityId: e.target.value })}
                    /> */}

					<Input
						name="senderId"
						error={errors?.senderId}
						value={form.senderId}
						label={"Sender Id"}
						placeholder={"Sender Id"}
						onChange={(e) => setForm({ ...form, senderId: e.target.value })}
					/>
				</div>
				<div className="flex flex-col">
					<Select
						error={errors?.smsConfigId}
						label="Choose SMS Configuration"
						selectedValue={selectedSMSConfig}
						onSelect={setSelectedSMSConfig}
						options={configs.map((ob) => ({ label: ob.name, value: ob._id }))}
					/>
					{thatConfig && (
						<div className="text-xs text-gray-400">
							Having user id <b>{thatConfig.userId}</b>
						</div>
					)}
					{/*<Input name='userId' error={errors?.userId}
                        value={form.userId}
                        label={'User Id'} placeholder={'User Id'}
                        onChange={(e) => setForm({ ...form, userId: e.target.value })}
                    />
                    <Input name='password' error={errors?.password}
                        value={form.password}
                        label={'Password'} placeholder={'Password'}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                    />*/}
				</div>
				<div className="flex flex-row gap-6">
					<div className="flex-[3]">&nbsp;</div>
					<div className="flex-1">
						&nbsp;
						{loading ? (
							<Button className="w-full text-black bg-red-100 pointer-events-none ">
								Loading
							</Button>
						) : (
							<Button className="w-full " onClick={update}>
								Update
							</Button>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
